import React from 'react';
import styles from './assets/styles/styles.module.scss';
import { CountDescriptionText } from '~/constants/read_const';

class TestInstruction extends React.Component {
  state = {
    loading: false,
  }

  render() {
    const {
      instructionText,
      testDescription,
      gameStartText
    } = CountDescriptionText;
    const {
      gameStartClick,
    } = this.props;
    return (
      <div className={styles.instruction}>
        <h3 className={styles.caption}>{instructionText}</h3>
        <ul className={styles.description_list}>
          {testDescription.map((item, index) => (
            <li className={styles.description_item} key={index}>{item}</li>
          ))}
        </ul>
        <button className={`${styles.game_start_button} iq-tests-button`} type="button" onClick={gameStartClick}>
          {gameStartText}
        </button>
      </div>
    );
  }
}


export default TestInstruction;
